import { styled } from '@mui/material/styles';
import Button from './Button';
import { getThemeColors } from '../helpers/themeStyles';

const StyledTextButton = styled(Button)(({ theme }) => {
  const colors = getThemeColors(theme);

  return {
    backgroundColor: 'transparent',
    color: colors.textMuted,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  };
});

const TextButton = (props) => <StyledTextButton disableElevation disableRipple {...props} />;

export default TextButton;
